export enum OrderByEnum {
  ASCEDING = 'asc',
  DESCEDING = 'desc',
}
